import "keen-slider/keen-slider.min.css";
import React, { useCallback } from "react";
import { AppText, FlexDiv } from "src/Components/UI";
import { PhoenixIcon } from "src/Components/UI/Phoenix";
import { chevron_down, chevron_up, neutral } from "src/images/NewDesign";
import { theme } from "src/utils/theme";
import styled from "styled-components";

interface IKPITile {
  index: number;
  data: {
    metric: string;
    label: string;
    value: string;
    list_rank_of: string;
    improvement_status: number;
  };
  handleShowWindow: (metric: string) => void;
}

export const KPITile: React.FC<IKPITile> = ({ index, data, handleShowWindow }) => {
  const getIcon = useCallback((status: number) => {
    switch (status) {
      case 1:
        return chevron_up;
      case -1:
        return chevron_down;
      case 0:
        return neutral;
      default:
        return neutral;
    }
  }, []);
  const getIconColor = useCallback((status: number) => {
    switch (status) {
      case 1:
        return theme.icon.success.default;
      case -1:
        return theme.icon.danger.default;
      case 0:
        return theme.icon.neutral.default;
      default:
        return theme.icon.success.default;
    }
  }, []);

  return (
    <Container index={index} className="keen-slider__slide" onClick={() => handleShowWindow(data.metric)}>
      <AppText fontSize={8} fontWeight={600} lineHeight={12} uppercase>
        {data.label}
      </AppText>
      <FlexDiv align="center" justify="space-between">
        <AppText fontSize={14} fontWeight={500} lineHeight={20} uppercase>
          {Number(parseFloat(data.value)) % 1 === 0 ? parseInt(data.value) : parseFloat(data.value).toFixed(2)}
        </AppText>
        <FlexDiv align="center" gap={8}>
          <AppText fontSize={10} fontWeight={500} lineHeight={14} color={theme.text.neutral.secondary}>
            ({data.list_rank_of})
          </AppText>
          <ArrowIcon
            svg={getIcon(data.improvement_status)}
            color={getIconColor(data.improvement_status)}
            hoverColor={getIconColor(data.improvement_status)}
            size={16}
          />
        </FlexDiv>
      </FlexDiv>
    </Container>
  );
};

const Container = styled.div<{ index: number }>`
  min-width: 140px;
  max-width: 140px;
  height: 40px;

  padding: 4px 8px;

  border-radius: 6px;
  background-color: ${theme.fill.neutral.primary};

  opacity: 0;

  animation: ${theme.popup} 0.5s ease-in-out forwards;
  animation-delay: ${({ index }) => 0.05 * index}s;
`;

const ArrowIcon = styled(PhoenixIcon)`
  cursor: grab;
  :active {
    cursor: grabbing;
  }
`;
